<script setup>
const props = defineProps({
  id: String,
  required: {
    type: Boolean,
    default: false
  },  
  placeholderText: String,
  errorText: {
    type: String,
    default: false
  },
  options: Array,
  firstElementSelected: {
    type: Boolean,
    default: true
  }

})

const emit = defineEmits(['onChanged'])

const handleChange = (event) => {  
  emit('onChanged', {
    id: props.id,    
    value: event.target.value,
    valid: !props.required || event.target.value !== ''
  })
}
</script>

<template>
  <select class="form-select" :id="id" :aria-label="placeholderText" @change="handleChange">
    <option selected v-if="!firstElementSelected" value="">{{ placeholderText }}</option>
    <option :value="option.countryCode" v-for="option in options" :key="option.countryCode">{{ option.name }}</option>
  </select>
</template>

<style lang="scss" >
.form-select {
  height: calc(3rem + 2px);
}

</style>